/**
 * Gestor de bloqueo de suspensión de pantalla (Screen Wake Lock API).
 * Evita que la pantalla de la tablet de cocina o caja se apague por inactividad.
 */
let wakeLock: WakeLockSentinel | null = null;

export async function solicitarWakeLock(): Promise<boolean> {
  if (typeof window === 'undefined' || !('wakeLock' in navigator)) {
    return false;
  }

  try {
    wakeLock = await navigator.wakeLock.request('screen');
    wakeLock.addEventListener('release', () => {
      wakeLock = null;
    });
    return true;
  } catch (err) {
    console.warn('[wakelock] No se pudo obtener el bloqueo de pantalla:', err);
    return false;
  }
}

export function liberarWakeLock() {
  if (wakeLock) {
    wakeLock.release().catch(() => null);
    wakeLock = null;
  }
}
